module.exports = __webpack_public_path__ + "media/images/games/k2gender/truck-77be700c336d0a0a3bbc37f56f479d45.png";